module.exports = __webpack_public_path__ + "static/Erudex Logo -01-50eab409d72ad5489fead16410a0932d.png";